import React from 'react'
import { type AppBottomBarIconProps } from '../types'

export const SearchSVGIcon: React.FC<AppBottomBarIconProps> = ({
  isActive
}) => (
  <svg
    width="38"
    height="37"
    viewBox="0 0 38 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.46061 20.333C10.3658 22.4629 12.08 24.146 14.2261 25.012C16.3723 25.878 18.7745 25.856 20.9044 24.9508C23.0343 24.0456 24.7174 22.3314 25.5834 20.1853C26.4494 18.0392 26.4274 15.6369 25.5222 13.507C24.617 11.3771 22.9028 9.69405 20.7567 8.82805C18.6105 7.96205 16.2083 7.98406 14.0784 8.88924C11.9485 9.79443 10.2654 11.5086 9.39941 13.6548C8.53341 15.8009 8.55543 18.2031 9.46061 20.333V20.333Z"
      stroke={isActive ? '#1B294C' : '#93979F'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6609 23.0894L30.4285 29.8579"
      stroke={isActive ? '#1B294C' : '#93979F'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
